import { useEffect, useRef, useState } from "react";
import styles from "./LoadingOverlay.module.css";
import softindexLogo from "../../../assets/images/softindex-website-logo.webp";

export default function LoadingOverlay({
  isVisible,
  message = "Loading...",
  showLogo = true,
  minDisplayTime = 1000,
}) {
  const [shouldShow, setShouldShow] = useState(isVisible);
  const [isExiting, setIsExiting] = useState(false);
  const startTimeRef = useRef(null);
  const hideTimeoutRef = useRef(null);
  const exitTimeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
      if (exitTimeoutRef.current) clearTimeout(exitTimeoutRef.current);
    };
  }, []);

  useEffect(() => {
    if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
    if (exitTimeoutRef.current) clearTimeout(exitTimeoutRef.current);

    if (isVisible) {
      setShouldShow(true);
      setIsExiting(false);
      startTimeRef.current = Date.now();
      return;
    }

    const elapsed = startTimeRef.current ? Date.now() - startTimeRef.current : 0;
    const remainingTime = Math.max(0, minDisplayTime - elapsed);

    hideTimeoutRef.current = setTimeout(() => {
      setIsExiting(true);
      exitTimeoutRef.current = setTimeout(() => {
        setShouldShow(false);
      }, 200);
    }, remainingTime);
  }, [isVisible, minDisplayTime]);

  if (!shouldShow) return null;

  return (
    <div className={`${styles.overlay} ${isExiting ? styles.exiting : ""}`}>
      <div className={styles.content}>
        {showLogo && (
          <img
            src={softindexLogo}
            alt="Softindex"
            className={styles.logo}
            width="200"
            height="50"
          />
        )}
        <div className={styles.spinner}>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
        </div>
        {message && <p className={styles.message}>{message}</p>}
      </div>
    </div>
  );
}
